import { HTTPError } from 'ky';
import { useQuery } from '@tanstack/react-query';
import { ShopTypes } from '~/lib/data-contract';
import { ParcelServiceProvider } from '~/services/shop/types';
import { getParcelServicePoints } from '../../operations/checkout';

export default function useParcelServicePoints({
    provider = ParcelServiceProvider.PostNord,
    query,
    enabled,
}: Props) {
    return useQuery<ShopTypes.ParcelServicePointQueryResult, HTTPError | Error>(
        ['parcelServicePoints', provider, { query }],
        () => getParcelServicePoints(provider, query),
        {
            enabled,
            retry: 1,
        },
    );
}

interface Props {
    provider: ParcelServiceProvider;
    query: ShopTypes.ParcelServicePointQuery;
    enabled?: boolean;
}
